import React from "react";
import { useNavigate, useOutletContext } from "react-router";
import { toast } from "react-toastify";
import { OrderTotal } from "../styled";

const Total = ({ totalPrice, deliveryFee, totalPayable, onClickPay, isActive }) => {
  return (
    <OrderTotal>
      <div>
        <p>결제 금액</p>
        <ul>
          <li>
            <span className="tit">상품금액</span>
            <span className="cont">{formatNumber(totalPrice)}원</span>
          </li>
          <li>
            <span className="tit">배송비</span>
            <span className="cont">{formatNumber(deliveryFee)}원</span>
          </li>
          <li>
            <span className="tit">총 결제 금액</span>
            <span className="cont">{formatNumber(totalPayable)}원</span>
          </li>
        </ul>
      </div>
      <button className={isActive ? "active" : "loading"} onClick={onClickPay} disabled={!isActive}>
        주문하기
      </button>
    </OrderTotal>
  );
};

export default Total;
